import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import CToggleSwitch from "core/components/CToggleSwitch";
import { useEffect, useState } from "react";
import { useCheckNotificationPermission } from 'core/hooks/useNativePermission'
import { useUpdateSettingNotification } from "../hooks/notification";
import { useUser } from "modules/Auth/hooks";

const NotificationSetting = () => {

  useScrollToTop()
  const { userInfo } = useUser()
  console.log(userInfo, 'user')
  const { handleUpdateSetting } = useUpdateSettingNotification();
  const [stateNotification, setStateNotification] = useState((window as any)._APP_NOTIFICATION_PERMISSION);
  
  const checkNotificationPermission =  useCheckNotificationPermission(() => {
    
      if(stateNotification){
        (window as any)._APP_NOTIFICATION_PERMISSION = false;
      }
      setStateNotification(() => {
        const updatedState = !stateNotification ? true : false;
        
        const updatedSetting = {
          ...paramSettingPush,
          notifications_enabled: updatedState ? "ON" : "OFF"
        };
        handleUpdateSetting(updatedSetting);
        setParamSettingPush(updatedSetting);
        return updatedState;
      });

  }, stateNotification);

  (window as any)._nativeResponsePermission = (data?: any) => {
    let _data = data;
    if (typeof data === 'string') {
       _data = JSON.parse(data)
    }
    if (_data?.notification === false) {
      setStateNotification(false);
      (window as any)._APP_NOTIFICATION_PERMISSION = false;
    }
  }


  const [breakfastNotification, setBreakfastNotification] = useState(false);
  const [lunchNotification, setLunchNotification] = useState(false);
  const [dinnerNotification, setDinnerNotification] = useState(false);


  const stateSetting = {
    notifications_enabled: (window as any)._APP_NOTIFICATION_PERMISSION ? "ON" : "OFF",
    notification_breakfast: "OFF",
    notification_lunch: "OFF",
    notification_dinner: "OFF"
  }

  const [paramSettingPush, setParamSettingPush] = useState(stateSetting);

  const listNotificationPush = [
    {
      type: 'breakfast',
      title: _t('menu.LabelReceiveNotifyBreakfast'),
      isActive: breakfastNotification,
    },
    {
      type: 'lunch',
      title: _t('menu.LabelReceiveNotifyLunch'),
      isActive: lunchNotification,
    },
    {
      type: 'dinner',
      title: _t('menu.LabelReceiveNotifyDinner'),
      isActive: dinnerNotification,
    },
  ]
  const [listSuggestionPush, setListSuggestionPush] = useState(listNotificationPush);

  useEffect(() => {
    if (userInfo?.setting) {
      setParamSettingPush(prev => ({ ...prev, ...userInfo.setting }));
      setStateNotification(userInfo?.setting?.notifications_enabled === "ON" && stateNotification)
      setBreakfastNotification(userInfo?.setting?.notification_breakfast === "ON")
      setLunchNotification(userInfo?.setting?.notification_lunch === "ON")
      setDinnerNotification(userInfo?.setting?.notification_dinner === "ON")
      setListSuggestionPush(listSuggestionPush.map(item => {
        switch (item.type) {
          case 'breakfast':
            return { ...item, isActive: userInfo?.setting?.notification_breakfast === "ON" }
          case 'lunch':
            return { ...item, isActive: userInfo?.setting?.notification_lunch === "ON" }
          case 'dinner':
            return { ...item, isActive: userInfo?.setting?.notification_dinner === "ON" }
          default:
            return item
        }
      }))
    }
  }, [])
  console.log(listSuggestionPush, 'listSuggestionPush')

  const handleToggle = ({ item, state }: { item: any; state: boolean }) => {
    const updatedSetting = {
      ...paramSettingPush,
      [`notification_${item.type}`]: state ? "ON" : "OFF"
    };
  
    setParamSettingPush(updatedSetting);
    setListSuggestionPush(prev =>
      prev.map(i => (i.type === item.type ? { ...i, isActive: state } : i))
    );
  
    handleUpdateSetting(updatedSetting);
  };


  const handleToggleNotification = (data?:any) => {
    console.log(data, 'data')
    checkNotificationPermission();
    // if(data?.state){
    //   setStateNotification(data?.state);
    //   checkNotificationPermission()
    // }else {
    //   const updatedSettingOff = {
    //     ...paramSettingPush,
    //     notifications_enabled: "OFF"
    //   };
    //   setStateNotification(data?.state);
    //   handleUpdateSetting(updatedSettingOff);
    //   setParamSettingPush(updatedSettingOff);
    // }
  };

  return (
    <AppLayout className={"main-page-client  pt-[43px]"}>
      <PageHeader title={_t('auth.MenuNotificationSettings')} />
      <div className="bg-[#f4f4f4]">
        <div className="px-4 bg-white mb-2">
          <CToggleSwitch
            isActive={stateNotification}
            onChange={handleToggleNotification}
            ariaLabel="Toggle breakfast notifications"
            title={_t('menu.OnOffNotification')}
          />
        </div>
        <section className="px-4 py-0 w-full bg-white">
          <div className={`flex flex-col w-full`} >
            <div className="px-0 py-5 text-[14px] font-medium tracking-tighter border-b border-solid border-b-zinc-100 text-neutral-900 block">
              {_t('menu.LabelReceiveNotificationSuggestion')}
            </div>
            {listSuggestionPush.map((item, index) => (
              <CToggleSwitch
                key={index}
                item={item}
                isActive={item.isActive}
                onChange={handleToggle}
                ariaLabel="Toggle breakfast notifications"
                title={item.title}
              />))}
          </div>
        </section>

      </div>

    </AppLayout>
  );
};

export default NotificationSetting;
